import { FormEditor } from './../../models/editors/form-editor.base.model';

export class Switch extends FormEditor<boolean> {
    public controlType = 'switch';
    public labelFalse: string;

    constructor(options: {} = {}) {
        super(options);
        this.labelFalse = options['labelFalse'] || this.label;
    }
}
